/* eslint-disable jira/integration/test-id-by-folder-structure */
/** @jsx jsx */
import { type ReactNode, memo } from 'react';
import { jsx, css } from '@compiled/react';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const TabDetails = ({
	onClick,
	preview,
	label,
	description,
}: {
	onClick: () => void;
	preview: ReactNode;
	label: string;
	description: string;
}) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={detailsWrapperStyles} role="region" aria-live="polite">
			<Stack alignInline="start" space="space.200" xcss={columnStyles}>
				<Box xcss={imageWrapperStyles}>{preview}</Box>
				<Stack space="space.050">
					<Heading
						size="xsmall"
						testId="navigation-kit-add-tab.ui.content.details.tab-details.heading"
					>
						<span css={headingExtraStyles}>{label}</span>
					</Heading>
					<Box xcss={descriptionStyles}>{description}</Box>
				</Stack>
				<Button appearance="primary" onClick={onClick}>
					{formatMessage(messages.addViewButton)}
				</Button>
			</Stack>
		</Box>
	);
};

export default memo(TabDetails);

const columnStyles = xcss({
	paddingInline: 'space.500',
	width: '100%',
});
const descriptionStyles = xcss({
	color: 'color.text.subtle',
	font: token('font.body.UNSAFE_small'),
});
const imageWrapperStyles = xcss({
	width: '100%',
});
const detailsWrapperStyles = xcss({
	borderStyle: 'solid',
	borderColor: 'color.border',
	borderWidth: 'border.width.0',
	borderInlineStartWidth: 'border.width',
	flexBasis: '320px',
	backgroundColor: 'elevation.surface.sunken',
	display: 'flex',
	paddingBlockStart: 'space.500',
});

const headingExtraStyles = css({
	wordBreak: 'break-all',
});
